import { Stack } from '@mui/material'
import { Typography } from '@eventr/common-storybook'
import { getValue } from '../../utils'
import { ColoursObj } from '@eventr/common-storybook'

interface ITimeDurationProps {
    data: any
    renderOptions: ITimeDurationOptions
}
interface ITimeDurationOptions {
    from: string
    to: string
}

export const TimeDuration = ({ data, renderOptions }: ITimeDurationProps) => {
    return (
        <>
            {data[renderOptions.from] && (
                <Stack direction="row">
                    <Typography variant="mobileH2">
                        {getValue(data[renderOptions.from])}
                    </Typography>
                    {data[renderOptions.to] && (
                        <Typography
                            variant="mobileH2"
                            color={ColoursObj.shades.shade2}
                        >
                            &nbsp;- {getValue(data[renderOptions.to])}
                        </Typography>
                    )}
                </Stack>
            )}
        </>
    )
}
